<template>
  <div class="mt-3">
    <v-server-table
      ref="fundsTable"
      url="fundsfiles/"
      :columns="columns"
      :options="options"
      @pagination="onPagination"
    >
      <!-- FILE NAME -->
      <template v-slot:file_name="{ row }">
        <div class="table-main-class">
          {{ row.path.split('/').pop() }}
        </div>
      </template>

      <!-- UPLOAD DATE -->
      <template v-slot:upload_date="{ row }">
        <div class="table-main-class">
          {{ row.upload_date | transformDate("MMMM Do YYYY") }}
        </div>
        <div class="table-sub-class text-sm">
          {{ row.upload_date | transformDate("h:mm a") }}
        </div>
      </template>

      <!-- ACTIONS COLUMN -->
      <template v-slot:actions="{ row }">
        <div class="d-flex align-items-center">
          <div
            v-b-tooltip.hover
            :title="selectedFundsFile.id === row.id ? $t('collapse'): $t('view')"
            class="table-sub-class text-center clickable mr-4"
            @click="selectRow(row)"
          >
            <i :class="selectedFundsFile.id === row.id ? 'fa fa-chevron-up':'fa fa-chevron-down'" />
          </div>
          <div
            v-b-tooltip.hover
            :title="isHidden(row.id) ? $t('show'): $t('hide')"
            class="table-sub-class text-center clickable mr-4"
            @click="toggleVisibility(row)"
          >
            <i class="fas fa-eye-slash" v-if="isHidden(row.id)" />
            <i class="fas fa-eye" v-else />
          </div>
        </div>
      </template>

      <!-- FUNDS TABLE -->
      <template v-slot:child_row="{ row }">
        <FundsTable :id="row.id" :key="row.id" />
      </template>
    </v-server-table>
  </div>
</template>


<script>
import { capitalize, get } from "lodash"
import {
  doRequest,
  responsePaginatedAdapter,
} from "@/assets/libs/utils"
import { Event } from "vue-tables-2"
import FundsTable from "./FundsTable"
import { listRouteMixin } from "@/utils/mixins"
import { mapMutations } from "vuex"

export default {
  name: "FundsFilesListTable",
  mixins: [listRouteMixin],
  components: {
    FundsTable
  },
  data () {
    return {
      selectedFundsFile: {},
      hiddenList: [],
      columns: ["file_name", "upload_date", "actions"],
      options: {
        sortable: [],
        customFilters: ["hidden"],
        initFilters: { "hidden": "" },
        headings: {
          file_name: capitalize(this.$t("fileName")),
          upload_date: capitalize(this.$t("uploadDate")),
          actions: "",
        },
        requestFunction (params) {
          const queryParams = { ...params, ...this.$route.query }
          this.page = Number(get(queryParams, "page", 1))
          return doRequest(this.url, queryParams)
        },
        responseAdapter: resp => {
          return responsePaginatedAdapter(resp)
        },
      }
    }
  },
  watch: {
    hiddenList (value) {
      let hidden = this.showHiddenFundFiles ? "" : value.toString()
      Event.$emit("vue-tables.filter::hidden", hidden)
    },
    showHiddenFundFiles (show) {
      let hidden = show ? "" : this.hiddenList.toString()
      if (!show) this.$refs.fundsTable.setPage(1)
      Event.$emit("vue-tables.filter::hidden", hidden)
    }
  },
  created () {
    this.setStatusFilter(null)
    this.setUseTypeFilter(null)
  },
  methods: {
    selectRow (row) {
      const { fundsTable } = this.$refs

      if (this.selectedFundsFile.id === row.id) {
        fundsTable.toggleChildRow(row.id)
        this.selectedFundsFile = {}
      } else {
        fundsTable.toggleChildRow(this.selectedFundsFile.id)
        fundsTable.toggleChildRow(row.id)
        this.selectedFundsFile = row
      }
    },
    isHidden (id) {
      return this.hiddenList.includes(id)
    },
    retrieveHiddenList () {
      let savedHiddenFundsFile = localStorage.getItem("hiddenFundsFile") || "[]"
      let hidden = JSON.parse(savedHiddenFundsFile)
      return hidden
    },
    toggleVisibility (row) {
      this.hiddenList = this.updateHiddenList(row.id)
    },
    updateHiddenList (id) {
      const hiddenList = this.retrieveHiddenList()

      if (hiddenList.includes(id) && this.isHidden(id)) {
        let updatedList = [ ...hiddenList ].filter(item => item !== id)
        localStorage.setItem("hiddenFundsFile", JSON.stringify(updatedList))
      } else {
        localStorage.setItem("hiddenFundsFile", JSON.stringify(hiddenList.concat(id)))
      }
      return this.retrieveHiddenList()
    },
    ...mapMutations("ui", ["setStatusFilter", "setUseTypeFilter"])
  },
  mounted () {
    this.hiddenList = this.retrieveHiddenList()
  },
  props: {
    showHiddenFundFiles: {
      type: Boolean,
      default: false,
    }
  }
}
</script>
